import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-98153ffc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-administrator-dashboard-root-notifications" }
const _hoisted_2 = { class: "box" }
const _hoisted_3 = { class: "box__headline" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, " Obavijesti ", -1))
const _hoisted_5 = {
  key: 0,
  class: "box__list"
}
const _hoisted_6 = { class: "content" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "message" }
const _hoisted_9 = { class: "date-and-action" }
const _hoisted_10 = { class: "date" }
const _hoisted_11 = { class: "action" }
const _hoisted_12 = {
  key: 1,
  class: "box__message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAdministratorDashboardRootNotificationsFormCreateIndexVue = _resolveComponent("AppAdministratorDashboardRootNotificationsFormCreateIndexVue")!
  const _component_AppAdministratorDashboardRootNotificationsFormUpdateIndexVue = _resolveComponent("AppAdministratorDashboardRootNotificationsFormUpdateIndexVue")!
  const _component_AppAdministratorDashboardRootNotificationsFormRemoveIndexVue = _resolveComponent("AppAdministratorDashboardRootNotificationsFormRemoveIndexVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_AppAdministratorDashboardRootNotificationsFormCreateIndexVue, { onGetNotifications: _ctx.getNotifications }, null, 8, ["onGetNotifications"])
      ]),
      (_ctx.notifications.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification, key) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "item",
                key: notification.id
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, " #" + _toDisplayString(key + 1) + " - " + _toDisplayString(notification.user.content.name) + " " + _toDisplayString(notification.user.content.surname), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(notification.content.message), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("strong", null, " Datum: " + _toDisplayString(_ctx.moment(notification.created_at).format('DD.MM.YYYY.')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.userId === notification.user_id)
                        ? (_openBlock(), _createBlock(_component_AppAdministratorDashboardRootNotificationsFormUpdateIndexVue, {
                            key: 0,
                            notification: notification,
                            onGetNotifications: _ctx.getNotifications
                          }, null, 8, ["notification", "onGetNotifications"]))
                        : _createCommentVNode("", true),
                      (_ctx.userId === notification.user_id)
                        ? (_openBlock(), _createBlock(_component_AppAdministratorDashboardRootNotificationsFormRemoveIndexVue, {
                            key: 1,
                            notification: notification,
                            onGetNotifications: _ctx.getNotifications
                          }, null, 8, ["notification", "onGetNotifications"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_12, " Nema podataka... "))
    ])
  ]))
}